import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Calendar, Card, Col, Form, Radio, Row, Select } from "antd";
import { Option } from "antd/es/mentions";
import TextArea from "antd/es/input/TextArea";
import { Navigate, useNavigate } from "react-router-dom";

const AppointmentScheduleVisit = () => {
    const Navigate = useNavigate();

    return (<>
        <section>
            <h5 className="fw-bold mb-2">Evisit</h5>
            <div className="bg-grey mt-1">
                <p className="p-2 fs-6 fw-semibold"><FontAwesomeIcon icon={faCircleInfo} />&nbsp; If you need an appointment for next 24hrs, Please call us at(123) 123 1234.</p>
            </div>
            <Card>
                <Row gutter={[18, 10]}>
                    <Col xl={8} lg={8} md={12} sm={20} xs={22}>
                        <Form layout="vertical">
                            <Form.Item label="Why is this appointment needed?" required>
                                <Select defaultValue="--Select--">
                                    <Option>--Select--</Option>
                                    <Option>TeleMedicine</Option>
                                    <Option>TeleMedicine 2</Option>
                                    <Option>TeleMedicine 3</Option>
                                </Select>
                            </Form.Item>
                        </Form>
                    </Col>
                    <Col xl={8} lg={8} md={12} sm={20} xs={22}>
                        <Form layout="vertical">
                            <Form.Item label="What Location" required>
                                <Select defaultValue="--Select--">
                                    <Option>--Select--</Option>
                                </Select>
                            </Form.Item>
                        </Form>
                    </Col>
                    <Col xl={8} lg={8} md={12} sm={20} xs={22}>
                        <Form layout="vertical">
                            <Form.Item label="Need a Specific Doctor">
                                <Select defaultValue="--Select--">
                                    <Option>--Select--</Option>
                                </Select>
                            </Form.Item>
                        </Form>
                    </Col>
                </Row>
                <hr />
                <h6>Select Appointment Slot</h6>
                <Row gutter={[20, 10]} justify={"space-around"}>
                    <Col xl={12} lg={12}>
                        <Calendar fullscreen={false} />
                    </Col>
                    <Col xl={10} lg={12}>
                        <p className="fs-6 fw-semibold mb-1">A Couple of Questions</p>
                        <Form layout="vertical">
                            <Form.Item label="Are you experiencing flu like symptoms?" required>
                                <Radio.Group value={1}>
                                    <Radio value={1}>Yes</Radio>
                                    <Radio value={2}>No</Radio>
                                </Radio.Group>
                            </Form.Item>
                            <Form.Item label="Are you experiencing cough, fever or shortness of breath?" required>
                                <Radio.Group value={2}>
                                    <Radio value={1}>Yes</Radio>
                                    <Radio value={2}>No</Radio>
                                </Radio.Group>
                            </Form.Item>
                            <Form.Item label="Have you been exposed to or in direct contact with someone with confirmed or suspected Coronavirus?" >
                                <Radio.Group value={1}>
                                    <Radio value={1}>Yes</Radio>
                                    <Radio value={2}>No</Radio>
                                </Radio.Group>
                            </Form.Item>
                            <Form.Item label="Are you attempting to schedule a flu shot?" required>
                                <Radio.Group value={2}>
                                    <Radio value={1}>Yes</Radio>
                                    <Radio value={2}>No</Radio>
                                </Radio.Group>
                            </Form.Item>
                        </Form>
                    </Col>
                </Row>
                <hr />
                <Row gutter={[20, 10]}>
                    <Col xl={8} lg={8} md={12} sm={20} xs={22}>
                        <Form layout="vertical">
                            <Form.Item label="What are your symptoms?">
                                <TextArea rows={3} />
                            </Form.Item>
                        </Form>
                    </Col>
                    <Col xl={8} lg={8} md={12} sm={20} xs={22}>
                        <Form layout="vertical">
                            <Form.Item label="Do you have any special needs?">
                                <TextArea rows={3} />
                            </Form.Item>
                        </Form>
                    </Col>
                    <Col xl={8} lg={8} md={12} sm={20} xs={22}>
                        <Form layout="vertical">
                            <Form.Item label="How could we contact you for this appointment?" required>
                                <Radio.Group value={1} >
                                    <Radio value={1}>By Message</Radio>
                                    <Radio value={2}>By Call</Radio>
                                </Radio.Group>
                                <TextArea rows={2} />
                            </Form.Item>
                        </Form>
                    </Col>
                </Row>
                <div className="text-end">
                    <Button className="primary btn px-3" onClick={() => Navigate("/appointmentdetailschedule")} size="large" >Next</Button>
                </div>
            </Card>
        </section>
    </>)
}
export default AppointmentScheduleVisit;